export default "__VITE_ASSET__CEERh1EY__"